import { useTranslation } from "react-i18next";
import { CheckCircle2, Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export interface OwnerSuccessStepProps {
  onGoToDashboard: () => void;
  finishing: boolean;
}

export function OwnerSuccessStep({
  onGoToDashboard,
  finishing,
}: OwnerSuccessStepProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Card className="overflow-hidden border-0 bg-gradient-to-br from-primary via-primary to-accent/90 shadow-lg shadow-primary/20 transition-shadow duration-200">
      <CardContent className="flex flex-col items-center gap-6 py-10 text-center sm:py-12">
        <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-white/20 text-white shadow-inner">
          <CheckCircle2 className="h-9 w-9" aria-hidden />
        </div>
        <div className="space-y-3">
          <h2 className="text-xl font-semibold text-white drop-shadow-sm sm:text-2xl">
            {t("onboarding.ownerSuccessCardTitle")}
          </h2>
          <p className="text-sm leading-relaxed text-white/95 sm:text-base">
            {t("onboarding.ownerSuccessCardBody")}
          </p>
        </div>
        <Button
          size="lg"
          variant="secondary"
          className="mt-2 transition-colors duration-150 hover:bg-white/95"
          onClick={onGoToDashboard}
          disabled={finishing}
        >
          {finishing ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              {t("onboarding.finishing")}
            </>
          ) : (
            t("onboarding.goToDashboard")
          )}
        </Button>
      </CardContent>
    </Card>
  );
}
